module.exports = __webpack_public_path__ + "assets/Psi.e2bc608c779a93fe614958286d9bcef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Psi.png
// module id = 844
// module chunks = 0